import { useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import React, { useCallback } from "react";
import { EpisodeSlider } from "./episodeList";
import _ from "lodash";
import { useInputMode } from "../../utils/hooks/useInputMode";

/**
 * Season Selector Button - styled component
 * Selected: Red background + white text
 * Focused: White background + red text
 */
var SeasonSelector = function SeasonSelector(props) {
  var selected = props.selected;
  var seasonKey = props.seasonKey;
  var onEnterPress = props.onEnterPress;
  var onFocus = props.onFocus;

  var focusResult = useFocusable({
    onEnterPress: onEnterPress,
    onFocus: onFocus,
  });
  var focused = focusResult.focused;
  var ref = focusResult.ref;
  var focusSelf = focusResult.focusSelf;

  var inputModeResult = useInputMode();
  var setMouseFocus = inputModeResult.setMouseFocus;
  var handleMouseEnter = useCallback(function () {
    setMouseFocus(true);
    focusSelf();
  }, [focusSelf, setMouseFocus]);

  return React.createElement("button", {
    ref: ref,
    onClick: onEnterPress,
    onMouseEnter: handleMouseEnter,
    className:
      "legacy-season-button" +
      (selected ? " is-selected" : "") +
      (focused ? " is-focused" : ""),
    type: "button",
  }, "فصل " + seasonKey);
};

var SeriesEpisodes = function SeriesEpisodes(props) {
  var seasons = props.seasons;
  var slug = props.slug;
  var onFocus = props.onFocus;
  var movie = props.movie;

  var selectedSeasonState = React.useState(1);
  var selectedSeason = selectedSeasonState[0];
  var setSelectedSeason = selectedSeasonState[1];

  var groupedEpisodes = _.groupBy(seasons, "seasonNumber");
  var seasonDetail = Object.keys(groupedEpisodes).map(function (key) {
    var obj = {};
    obj[key] = groupedEpisodes[key];
    return obj;
  });

  return React.createElement(React.Fragment, null,
    React.createElement("div", { className: "legacy-seasons-container" },
      seasonDetail.map(function (season, index) {
        var seasonKey = Object.keys(season)[0];
        return React.createElement(SeasonSelector, {
          season: season,
          key: "episode_" + index,
          selected: selectedSeason == seasonKey,
          seasonKey: seasonKey,
          onEnterPress: function () {
            setSelectedSeason(seasonKey);
          },
          onFocus: onFocus,
        });
      })
    ),
    React.createElement(EpisodeSlider, {
      movies: groupedEpisodes[selectedSeason],
      slug: slug,
      onFocus: onFocus,
      movie: movie,
    })
  );
};

export default SeriesEpisodes;
